import { createContext, useContext, useMemo } from 'react'

import { BlockConfigAlgolia } from '@Globals/Algolia/Types'

export const BlockContext = createContext({ blockID: 'unknown', blockType: 'unknown', id: 'unknown' })

export interface BlockConfig {
  algolia?: BlockConfigAlgolia
}

export const BlockConfigContext = createContext<Record<string, BlockConfig>>({})

export const useBlockConfig = () => {
  const { blockID, blockType } = useContext(BlockContext)
  const blockConfig = useContext(BlockConfigContext)
  return useMemo(() => blockConfig[`${blockType}:${blockID}`] ?? null, [blockConfig, blockID, blockType])
}
